<template>
  <div class="app-container">
    <!-- 主容器 -->
    <el-row :gutter="20">
      <el-col :span="24" :xs="24">
        <!-- 搜索表单 -->
        <el-form :model="queryParams" ref="queryParams" size="small" v-show="showSearch" label-width="100px">
          <!-- 搜索条件行 -->
          <el-row :gutter="24" type="flex" justify="start" style="flex-wrap: wrap;">
            <!-- 客户名称搜索 -->
            <el-col :span="6">
              <el-form-item label="客户名称" prop="compNames">
                <el-input v-model="queryParams.compNames" placeholder="请输入客户名称" @keyup.enter.native="handleQuery" />
                <CustomerDetails v-model="queryParams.compNames" />
              </el-form-item>
            </el-col>
            <!-- 使用单位搜索 -->
            <el-col :span="6">
              <el-form-item label="使用单位" prop="usingUnit">
                <el-input v-model="queryParams.usingUnit" placeholder="请输入使用单位" clearable @keyup.enter.native="handleQuery" />
              </el-form-item>
            </el-col>
            <!-- 检测时间搜索 -->
            <el-col :span="6">
              <el-form-item label="检测时间" prop="testDateRange">
                <el-date-picker v-model="queryParams.testDateRange" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" style="width: 100%;"
                                @change="handleQuery" />
              </el-form-item>
            </el-col>
            <!-- 开票单位名称搜索 -->
            <el-col :span="6">
              <el-form-item label="开票单位名称" prop="invoiceUnitName">
                <el-input v-model="queryParams.invoiceUnitName" placeholder="请输入开票单位名称" clearable @keyup.enter.native="handleQuery" />
              </el-form-item>
            </el-col>
            <!-- 收款状态搜索 -->
            <el-col :span="6">
              <el-form-item label="收款状态" prop="status">
                <el-select v-model="queryParams.status" placeholder="请选择收款状态" clearable style="width: 100%;" @change="handleQuery">
                  <el-option label="未收款" value="-1" />
                  <el-option label="已收款" value="1" />
                </el-select>
              </el-form-item>
            </el-col>            
            <!-- 设备识别码搜索 -->
            <el-col :span="6">
              <el-form-item label="识别码" prop="OIDNO">
                <el-input v-model="queryParams.OIDNO" placeholder="请输入识别码" clearable @keyup.enter.native="handleQuery" />
              </el-form-item>
            </el-col>
            <!-- 使用地点搜索 -->
            <el-col :span="6">
              <el-form-item label="设备使用地点" prop="eqpUseAddr">
                <el-input v-model="queryParams.eqpUseAddr" placeholder="请输入使用地点" clearable @keyup.enter.native="handleQuery" />
              </el-form-item>
            </el-col>
          </el-row>

          <!-- 功能按钮区域 -->
          <div style="text-align: center;margin-bottom: 10px;">
            <PermissionMethodToolbar :url="url" :id="'toolbar'" @handleSearch="handleQuery" @handlePayment="handlePayment" @exportToExcel="exportToExcel" />
          </div>

          <!-- 数据表格 -->
          <el-table id="table" :data="tableData" border style="width: 100%; margin-top: 20px" :header-cell-style="{ background: '#d8e8fb', textAlign: 'left', borderColor: '#CCC' }"
                    @selection-change="handleSelectionChange" height="500">
            <!-- 多选框列 -->
            <el-table-column type="selection" width="55" align="left"></el-table-column>
            <!-- 识别码列 -->
            <el-table-column label="识别码" align="left" prop="OIDNO" min-width="120" show-overflow-tooltip></el-table-column>
            <!-- 检测时间列 -->
            <el-table-column label="检测时间" align="left" prop="testEmployeeDate" min-width="120" show-overflow-tooltip>
              <template slot-scope="scope">
                {{ scope.row.testEmployeeDate ? scope.row.testEmployeeDate.split(' ')[0] : '' }}
              </template>
            </el-table-column>
            <!-- 层数/高度/长度列 -->
            <el-table-column label="层数/高度/长度" align="left" prop="ELEFLOORNUMBER" min-width="120" show-overflow-tooltip></el-table-column>
            <!-- 使用单位列 -->
            <el-table-column label="使用单位" align="left" prop="usingUnit" min-width="150" show-overflow-tooltip></el-table-column>
            <!-- 开票单位名称列 -->
            <el-table-column label="开票单位名称" align="left" prop="invoiceUnitName" min-width="180" show-overflow-tooltip></el-table-column>
            <!-- 客户名称列 -->
            <el-table-column label="客户名称" align="left" prop="compName" min-width="150" show-overflow-tooltip></el-table-column>
            <!-- 设备使用地点列 -->
            <el-table-column label="设备使用地点" align="left" prop="eqpUseAddr" min-width="180" show-overflow-tooltip></el-table-column>
            <!-- 标准价列 -->
            <el-table-column label="标准价" align="left" prop="testCharge" min-width="100" show-overflow-tooltip></el-table-column>
            <!-- 折扣列 -->
            <el-table-column label="折扣" align="left" prop="custDiscount" min-width="80" show-overflow-tooltip></el-table-column>
            <!-- 折后价列 -->
            <el-table-column label="折后价" align="left" prop="finalPrice" min-width="100" show-overflow-tooltip></el-table-column>
            <el-table-column label="125%试验费用" align="left" prop="discTestOtherFee" min-width="120" show-overflow-tooltip></el-table-column>
            <el-table-column label="总费用" align="left" prop="totalTestAmount" min-width="100" show-overflow-tooltip></el-table-column>
            <el-table-column label="收款金额" align="left" prop="actualReceiptAmount" min-width="140" show-overflow-tooltip></el-table-column>
            <el-table-column label="收款登记人" align="left" prop="payeeName" min-width="120" show-overflow-tooltip></el-table-column>
            <el-table-column label="收款时间" align="left" prop="receiptTime" min-width="140" show-overflow-tooltip>
              <template slot-scope="scope">
                {{ scope.row.receiptTime ? scope.row.receiptTime.split(' ')[0] : '' }}
              </template>
            </el-table-column>

            <!-- 委托编号列 -->
            <el-table-column label="委托编号" align="left" prop="entrustNum" min-width="180" show-overflow-tooltip></el-table-column>
            <!-- 检测员列 -->
            <el-table-column label="检测员" align="left" prop="employeeName" min-width="100" show-overflow-tooltip></el-table-column>
            <!-- 操作列 -->
            <el-table-column label="操作" align="left" prop="operation" min-width="120" show-overflow-tooltip fixed="right">
              <template slot-scope="scope">
                <PermissionMethodRow :url="url" :id="'rowtoolbar'" :disabledButtons="getDisabledButtons(scope.row)" @handleCancel="handleCancel(scope.row)" />
              </template>
            </el-table-column>
          </el-table>

          <!-- 分页组件 -->
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="queryParams.currPage" :page-size="queryParams.pageSize"
                         layout="total, sizes, prev, pager, next, jumper" :total="total" style="margin-top: 20px; text-align: right;" :page-sizes="[10, 20, 50, 100,200,500,1000]" />
        </el-form>
      </el-col>
    </el-row>

    <!-- 收款弹窗组件 -->
    <PaymentDialog ref="paymentDialog" @refresh="getList" />
  </div>
</template>

<script>
// 导入API接口
import { queryReceivablesList, cancelReceivables, exportReceivables } from '@/api/contract/contract'
// 导入收款弹窗组件
import PaymentDialog from './PaymentDialog.vue'
// 导入权限按钮组件
import PermissionMethodToolbar from '@/components/button/PermissionMethodToolbar.vue'
import PermissionMethodRow from '@/components/button/PermissionMethodRow.vue'

export default {
  name: 'ReceivablesManagement',
  props: {
    // 页面URL，用于权限按钮组件
    url: {
      type: String,
      default: ''
    }
  },
  components: {
    PaymentDialog,
    PermissionMethodToolbar,
    PermissionMethodRow
  },
  data () {
    return {
      // 显示搜索条件
      showSearch: true,
      // 表格数据
      tableData: [],
      // 遮罩层
      loading: true,
      // 总条数
      total: 0,
      // 查询参数
      queryParams: {
        currPage: 1,
        pageSize: 10,
        compNames: '',
        usingUnit: '',
        invoiceUnitName: '',
        eqpUseAddr: '',
        OIDNO: '',
        testDateRange: [],
        status: '-1' // 默认（未收款）
      },
      // 选中的数据
      selectedRows: []
    };
  },
  created () {
    // 页面加载时查询列表
    this.getList()
  },
  methods: {
    /**
     * 搜索按钮点击事件
     */
    handleQuery () {
      this.queryParams.currPage = 1
      this.getList()
    },
    /**
     * 每页条数变化
     * @param {number} size - 每页条数
     */
    handleSizeChange (size) {
      this.queryParams.pageSize = size
      this.queryParams.currPage = 1
      this.getList()
    },
    /**
     * 页码变化
     * @param {number} page - 当前页码
     */
    handleCurrentChange (page) {
      this.queryParams.currPage = page
      this.getList()
    },

    /**
     * 查询列表数据
     */
    getList () {
      this.loading = true
      // 调用查询接口
      queryReceivablesList(this.queryParams).then(res => {
        if (res.retCode === 'ok') {
          this.tableData = res.additionalData.records || res.additionalData.list || []
          this.total = res.additionalData.total
          this.loading = false
        } else {
          this.$message.error(res.retMsg)
          this.loading = false
        }
      }).catch(error => {
        console.error('查询失败:', error)
        this.$message.error('查询失败')
        this.loading = false
      })
    },

    /**
     * 多选框选中数据变化事件
     * @param {Array} selection - 选中的数据数组
     */
    handleSelectionChange (selection) {
      this.selectedRows = selection
    },

    /**
     * 收款按钮点击事件
     */
    handlePayment () {
      // 检查是否选择了数据
      if (this.selectedRows.length === 0) {
        this.$message.warning('请至少选择一条数据')
        return
      }

      // 检查是否有已完全收款的数据：优惠收款已结清，或累计实收 >= 总费用（折后价+125%试验费用）
      const hasFullyPaid = this.selectedRows.some(row => {
        if (row.paymentStatus === 3) {
          return true
        }
        const totalFee = parseFloat(row.totalTestAmount) || 0
        const paid = parseFloat(row.totalPaidAmount) || 0
        return totalFee > 0 && paid >= totalFee
      })
      if (hasFullyPaid) {
        this.$message.warning('所选列表中存在已收款数据，不需要收款')
        return
      }

      // 检查客户名称和使用单位是否一致
      const firstRow = this.selectedRows[0]
      const isConsistent = this.selectedRows.every(row =>
        row.compName === firstRow.compName && row.usingUnit === firstRow.usingUnit
      )

      if (!isConsistent) {
        this.$message.warning('所选数据的客户名称和使用单位必须一致才能一起收款')
        return
      }

      // 打开收款弹窗
      this.$refs.paymentDialog.openDialog(this.selectedRows)
    },

    /**
     * 撤销收款按钮点击事件
     * @param {Object} row - 当前行数据
     */
    handleCancel (row) {
      // 检查是否已收款
      if (!row.receiptNo) {
        this.$message.warning('该数据未收款，无需撤销')
        return
      }

      // 确认撤销
      this.$confirm('确定要撤销该收款记录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 调用撤销接口
        cancelReceivables(row.receiptNo).then(res => {
          if (res.retCode === 'ok') {
            this.$message.success('撤销成功')
            this.getList()
          } else {
            this.$message.error(res.retMsg || '撤销失败')
          }
        }).catch(error => {
          console.error('撤销失败:', error)
          this.$message.error('撤销失败')
        })
      }).catch(() => {
        this.$message.info('已取消撤销')
      })
    },

    /**
     * 导出按钮点击事件
     */
    exportToExcel () {
      this.$message.success('正在导出收款数据...')

      // 调用导出接口
      exportReceivables(this.queryParams).then(response => {
        // 创建Blob对象
        const blob = new Blob([response], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const url = window.URL.createObjectURL(blob);

        // 创建下载链接
        const link = document.createElement('a');
        link.href = url;
        link.download = '收款管理.xlsx';

        // 触发下载
        link.style.display = 'none';
        document.body.appendChild(link);
        link.click();

        // 清理
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);

        this.$message.success('导出成功')
      }).catch(error => {
        console.error('导出失败:', error)
        this.$message.error('导出失败：' + (error.message || '未知错误'))
      })
    },

    /**
     * 获取禁用的按钮列表
     * @param {Object} row - 当前行数据
     * @returns {Array} 禁用的按钮名称数组
     */
    getDisabledButtons (row) {
      // 如果没有status属性或者status值为0，禁用撤销按钮
      if (!row.hasOwnProperty('status') || row.status === 0) {
        return ['handleCancel']
      }
      return []
    }
  }
}
</script>

<style scoped>
/* 容器样式 */
.app-container {
  padding: 20px;
}
::v-deep .el-table__body-wrapper {
  z-index: 2;
}
</style>
